<template>
  <div>
    <create-dialog ref="CreateDialogRef" v-model="createShow"></create-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxGet } from '@/api/api/api'

import CreateDialog from './create.vue'

export default {
  components: {
    CreateDialog
  },
  data() {
    return {
      createShow: false,
      id: ''
    }
  },
  methods: {
    async fetchDetails(id) {
      try {
        this.id = id
        const url =
          Baseurl +
          `/shopeeGlobalProductInfo/getShopeeGlobalProductDetail/${id}`
        const res = await ajaxGet(url)
        const { code, data, message } = res.data
        if (code === 200) {
          this.createShow = true
          this.$nextTick(() => {
            this.$refs.CreateDialogRef.setFormData({
              id,
              ...data,
              type: 'show'
            })
          })
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
